import type { MenuCategory, MenuProduct } from "@/types";

export const menuCategories: MenuCategory[] = [
  { id: "mains", name: "الوجبات الرئيسية", icon: "ri-restaurant-2-line", isActive: true },
  { id: "starters", name: "المقبلات", icon: "ri-leaf-line", isActive: true },
  { id: "drinks", name: "المشروبات", icon: "ri-cup-line", isActive: true },
  { id: "desserts", name: "الحلويات", icon: "ri-cake-3-line", isActive: true },
];

export const menuProducts: MenuProduct[] = [
  {
    id: "p1",
    name: "كبسة دجاج",
    categoryId: "mains",
    price: 45,
    stock: 24,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20Saudi%20chicken%20kabsa%20rice%20dish%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-kabsa-chicken-01&orientation=squarish",
    description: "أرز بسمتي مع دجاج مشوي وتوابل الكبسة الأصلية",
  },
  {
    id: "p2",
    name: "مندي لحم",
    categoryId: "mains",
    price: 65,
    stock: 12,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20Saudi%20lamb%20mandi%20rice%20plate%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-mandi-meat-01&orientation=squarish",
    description: "لحم غنم طري مطبوخ على الطريقة المندية",
  },
  {
    id: "p3",
    name: "برياني دجاج",
    categoryId: "mains",
    price: 38,
    stock: 30,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20spiced%20chicken%20biryani%20bowl%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-biryani-chicken-01&orientation=squarish",
    description: "أرز بريانى بالتوابل الهندية وقطع الدجاج",
  },
  {
    id: "p4",
    name: "حمص بالطحينة",
    categoryId: "starters",
    price: 15,
    stock: 40,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20hummus%20tahini%20dip%20bowl%20with%20olive%20oil%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-hummus-01&orientation=squarish",
    description: "حمص كريمي مع الطحينة وزيت الزيتون",
  },
  {
    id: "p5",
    name: "سمبوسة مقرمشة",
    categoryId: "starters",
    price: 12,
    stock: 55,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20crispy%20golden%20sambosa%20pastries%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-sambosa-01&orientation=squarish",
    description: "سمبوسة بالخضار أو اللحم مقلية طازجة",
  },
  {
    id: "p6",
    name: "تبولة",
    categoryId: "starters",
    price: 16,
    stock: 0,
    isAvailable: false,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20fresh%20tabbouleh%20parsley%20salad%20bowl%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-food-tabbouleh-01&orientation=squarish",
    description: "بقدونس وبرغل وليمون ونعناع منعش",
  },
  {
    id: "p7",
    name: "شاي بالنعناع",
    categoryId: "drinks",
    price: 8,
    stock: 100,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20glass%20of%20mint%20tea%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-drink-mint-tea-01&orientation=squarish",
    description: "شاي ساخن مع نعناع طازج",
  },
  {
    id: "p8",
    name: "ليمون بالنعناع",
    categoryId: "drinks",
    price: 12,
    stock: 60,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20lemon%20mint%20iced%20drink%20glass%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-drink-lemon-mint-01&orientation=squarish",
    description: "عصير ليمون طازج مع النعناع والثلج",
  },
  {
    id: "p9",
    name: "كنافة بالجبن",
    categoryId: "desserts",
    price: 22,
    stock: 18,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20a%20slice%20of%20cheese%20kunafa%20dessert%20with%20pistachio%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-dessert-kunafa-01&orientation=squarish",
    description: "كنافة ذهبية بالجبن والقطر والفستق",
  },
  {
    id: "p10",
    name: "لقيمات",
    categoryId: "desserts",
    price: 14,
    stock: 25,
    isAvailable: true,
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20food%20photography%20of%20golden%20luqaimat%20sweet%20dumplings%20with%20date%20syrup%20on%20a%20clean%20light%20beige%20background%2C%20warm%20studio%20lighting%2C%20minimal%20styling%2C%20soft%20shadows&width=400&height=400&seq=yc-dessert-luqaimat-01&orientation=squarish",
    description: "لقيمات مقرمشة مغموسة بالدبس",
  },
];